"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _ButtonMinimalIcon = _interopRequireDefault(require("../../buttons/ButtonMinimalIcon"));
var _QuantityPicker = require("../../QuantityPicker");
var _InputRaw = _interopRequireDefault(require("@commerce-ui/core2/InputRaw"));
var _Select2Ui = _interopRequireDefault(require("../../Select2Ui"));
var _Button = _interopRequireDefault(require("@commerce-ui/core2/Button"));
var _ItemRow = _interopRequireDefault(require("../../selectables/ItemRow"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconPlus = function IconPlus(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 19.338v-13h1.2v13h-1.2z"
  }));
};
IconPlus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconMinus = function IconMinus(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }));
};
IconMinus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var QuantityPicker = function QuantityPicker(props) {
  var counter = props.controller || (0, _QuantityPicker.useQuantityPicker)(props);
  var ref = (0, _react.useRef)(null);
  var inputsDisplay = {
    select: counter.exceedsSelectRange ? {
      display: "none"
    } : {
      display: "flex"
    },
    input: counter.exceedsSelectRange ? {
      display: "block"
    } : {
      display: "none"
    }
  };
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "inline-flex",
      flexDirection: "row",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "neutral",
      ":focus-within": {
        borderColor: "main"
      },
      color: "main"
    },
    _ref: ref
  }, __jsx(_ButtonMinimalIcon["default"], counter.buttonDecrementProps, __jsx(IconMinus, null)), __jsx(_InputRaw["default"], (0, _extends2["default"])({}, counter.inputProps, {
    sx: _objectSpread(_objectSpread({}, inputsDisplay.input), {}, {
      width: "50px",
      height: 44,
      textAlign: "center",
      font: "base_sans",
      lineHeight: 1,
      color: "main"
    }),
    type: "number",
    noFocus: true
  })), __jsx(_Select2Ui["default"], (0, _extends2["default"])({
    "data-test": "quantity-picker"
  }, counter.selectProps, {
    button: function button(_ref) {
      var value = _ref.value;
      return __jsx(_Button["default"], {
        sx: _objectSpread(_objectSpread({}, inputsDisplay.select), {}, {
          minWidth: 50,
          height: 44,
          justifyContent: "center",
          alignItems: "center",
          font: "base_sans",
          lineHeight: 1,
          flex: 1
        })
      }, value);
    },
    selectable: __jsx(_ItemRow["default"], null),
    allowEmpty: false,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: function width(_ref2) {
      var anchorRect = _ref2.anchorRect;
      return ["70vw", null, anchorRect.width];
    },
    maxHeight: ["90vh", null, "auto"],
    root: {
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)"
    }
  })), __jsx(_ButtonMinimalIcon["default"], counter.buttonIncrementProps, __jsx(IconPlus, null)));
};
var _default = QuantityPicker;
exports["default"] = _default;